(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["career-employee-says"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".employee-says-swiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 FAQ script starting...');
  const details = document.querySelectorAll('.faq_tab-control');
  console.log('📄 Found FAQ items:', details.length);

  // ---- Log raw and processed data for every item ----
  details.forEach((el) => {
    console.log(
      `  #${el.dataset.index} | source: "${el.dataset.source}" | raw: "${el.dataset.raw}" | image: "${el.dataset.image}"`
    );
  });

  // ---- Accordion ----
  details.forEach((targetDetail) => {
    targetDetail.addEventListener('click', function() {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute('open');
        }
      });
    });
  });

  // ---- Image switching ----
  const faqImg = document.querySelector('.faq_imgs');
  if (!faqImg) {
    console.error('❌ .faq_imgs element not found!');
    return;
  }

  // Set initial image from first open FAQ
  const firstOpen = document.querySelector('.faq_tab-control[open]');
  if (firstOpen) {
    const initialImage = firstOpen.dataset.image;
    if (initialImage) {
      faqImg.style.background = `url(${initialImage}) no-repeat center center / cover`;
      console.log('✅ Initial image set from first open FAQ:', initialImage);
    } else {
      console.warn('⚠️ First open FAQ has empty data-image; keeping CSS fallback.');
    }
  }

  // Click handler – update image from clicked FAQ's data-image
  details.forEach((control) => {
    control.addEventListener('click', function() {
      const imgUrl = this.dataset.image;
      console.log(`🖱️ Clicked #${this.dataset.index} (${this.dataset.source}), image:`, imgUrl);
      if (imgUrl) {
        faqImg.style.background = `url(${imgUrl}) no-repeat center center / cover`;
        console.log('✅ Background updated to:', imgUrl);
      } else {
        console.warn(`⚠️ #${this.dataset.index} has no image; background unchanged.`);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dotd"] && !Shopify.designMode) return;
  try {
    
  /* Rating */
  const ratingElements = document.querySelectorAll(".dotd_rating");

ratingElements.forEach((ratingElement, index) => {
  const rating = parseFloat(ratingElement.getAttribute("data-rating"));
  const targetEle = ratingElement.querySelector(`#star_rating`);
  generateStarRating(rating, targetEle);
});

function generateStarRating(ratingValue, targetEle) {
  const fullStars = Math.floor(ratingValue);
  const hasHalfStar = ratingValue % 1 !== 0;
  let starsHTML = "";
  for (let i = 1; i <= 5; i++) {
    if (i <= fullStars) {
      starsHTML += '<span class="star">&#9733;</span>';
    } else if (hasHalfStar && i === fullStars + 1) {
      starsHTML += '<span class="star">&#9733;</span>';
    } else {
      starsHTML += '<span class="star">&#9734;</span>';
    }
  }
  targetEle.innerHTML = starsHTML;
}


/* Discount Percentage */

const itemElements = document.querySelectorAll(".dotd_disc_perc_item");

itemElements.forEach((itemElement) => {
  const finPrice = itemElement.getAttribute("data-fin-price");
  const mrp = itemElement.getAttribute("data-mrp");
  const targetElement = itemElement.querySelector(".dotd_disc_perc");
  updateDiscountPercentage(finPrice, mrp, targetElement);
});
  
  function updateDiscountPercentage(finPrice, mrp, targetElement) {
  const finPriceValue = parseFloat(finPrice.replace(/[^\d.]/g, ""));
  const mrpValue = parseFloat(mrp.replace(/[^\d.]/g, ""));
  const discountAmount = mrpValue - finPriceValue;
  const discountPercentage = (discountAmount / mrpValue) * 100;
  targetElement.innerText = `${discountPercentage.toFixed(2)}% off`;
}

const targetTimeP = document.getElementById("cdtimer_date_time");
const targetTimePvalueID = targetTimeP.getAttribute("cdtimer-date-time");

function updateCountdown() {
  const now = new Date();
  const targetDate = new Date(targetTimePvalueID);
  const timeDifference = targetDate - now;
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  // Pad single-digit values with a leading zero
  const paddedDays = days.toString().padStart(2, '0');
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');
  const paddedSeconds = seconds.toString().padStart(2, '0');

  // Update the countdown elements with padded values
  document.getElementById("cd_timer_day").textContent = paddedDays;
  document.getElementById("cd_timer_hour").textContent = paddedHours;
  document.getElementById("cd_timer_minute").textContent = paddedMinutes;
  document.getElementById("cd_timer_second").textContent = paddedSeconds;
}

setInterval(updateCountdown, 1000);
updateCountdown();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-promotion"] && !Shopify.designMode) return;
  try {
    
const spec_prom_prevButton = document.querySelector(".spec_prom_prev-button");
const spec_prom_nextButton = document.querySelector(".spec_prom_next-button");
const spec_prom_sliderContainer = document.querySelector(
  ".spec_prom_slider-container"
);

let spec_prom_position = 0;
const spec_prom_slides = Array.from(
  spec_prom_sliderContainer.getElementsByClassName("spec_prom_slide")
);
const spec_prom_totalSlides = spec_prom_slides.length;

// Display initial active slide number and total number of slides
const spec_prom_activeSlideNumber = document.querySelector(
  ".spec_prom_active-slide-number"
);
const spec_prom_totalSlideNumber = document.querySelector(
  ".spec_prom_total-slide-number"
);
spec_prom_activeSlideNumber.textContent = spec_prom_position + 1;
spec_prom_totalSlideNumber.textContent = spec_prom_totalSlides;

spec_prom_prevButton.addEventListener("click", spec_prom_slideToPrevImage);
spec_prom_nextButton.addEventListener("click", spec_prom_slideToNextImage);

function spec_prom_slideToPrevImage() {
  spec_prom_slides[spec_prom_position].classList.remove("active");
  spec_prom_position =
    (spec_prom_position - 1 + spec_prom_totalSlides) % spec_prom_totalSlides;
  spec_prom_slides[spec_prom_position].classList.add("active");

  // Update active slide number
  spec_prom_activeSlideNumber.textContent = spec_prom_position + 1;
}

function spec_prom_slideToNextImage() {
  spec_prom_slides[spec_prom_position].classList.remove("active");
  spec_prom_position = (spec_prom_position + 1) % spec_prom_totalSlides;
  spec_prom_slides[spec_prom_position].classList.add("active");

  // Update active slide number
  spec_prom_activeSlideNumber.textContent = spec_prom_position + 1;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsb-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const columns = document.querySelectorAll(".tsb_flex_column");

  columns.forEach((column) => {
    column.addEventListener("mouseover", function () {
      columns.forEach((col) => col.classList.remove("active"));
      this.classList.add("active");
      columns.forEach((col) => {
        if (!col.classList.contains("active")) {
          col.style.filter = "brightness(40%)";
        } else {
          col.style.filter = "none";
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
